// extracted by mini-css-extract-plugin
export default {"akpan_Container":"Joseph_akpan_Container__+4-sP","akpan_Wrapper":"Joseph_akpan_Wrapper__qdF7n","akpan_Link":"Joseph_akpan_Link__2Mwlp"};